<gbc-page-error-handler [content]="content" [pageError$]="pageError$"></gbc-page-error-handler>
<ng-template #content>
  <gbc-page-header [pageInfo]="pageInfo$ | async">
    <ng-container gbc-page-header-actions>
      <button gbc-menu-item (click)="editFacility()" angulartics2On="click" angularticsAction="editFacilityShown" angularticsCategory="mixitInstallation">
        <img src="./assets/svgs/edit.svg" style="margin-right: 10px" />
        {{ 'mixit-facility-page.edit-facility' | translate }}
      </button>
      <button gbc-menu-item (click)="editInstallation()" angulartics2On="click" angularticsAction="editInstallationShown" angularticsCategory="mixitInstallation">
        <img src="./assets/svgs/edit.svg" style="margin-right: 10px" />
        {{ 'mixit-installation-page.edit-installation' | translate }}
      </button>
    </ng-container>
  </gbc-page-header>
  <gbc-page-container>

    @if ((isMixitHeating$ | async) !== true || (isDirectValveControl$ | async)) {
      <gbc-message-tile
        data-test-id="mixit-configuration-info-message"
        icon="./assets/svgs/info-circle_outline.svg"
        title="{{ 'mixit-installation-page.configuration-not-supported-title' | translate }}"
        text="{{ 'mixit-installation-page.configuration-not-supported-text' | translate }}">
      </gbc-message-tile>
    }

    @if ((isMixitHeating$ | async) && (isDirectValveControl$ | async) !== true) {
      @if (premium$ | async) {
        <app-mixit-premium-dashboard
          [alarm$]="alarm$"
          [application$]="application$"
          [dataPoints$]="dataPoints$"
          [installation$]="installation$"
          [schematic$]="schematic$"
          data-test-id="mixit-premium-dashboard">
        </app-mixit-premium-dashboard>
      }
      @if ((premium$ | async) === false) {
        <app-mixit-freemium-dashboard
          [alarm$]="alarm$"
          [application$]="application$"
          [dataPoints$]="dataPoints$"
          [installation$]="installation$"
          [schematic$]="schematic$"
          data-test-id="mixit-freemium-dashboard">
        </app-mixit-freemium-dashboard>
      }
    }
  </gbc-page-container>
</ng-template>
